import { useLayoutEffect } from 'preact/hooks';

export function useSetVideoSlotURI(videoUri: string | undefined, videoSlot: HTMLVideoElement) {
  useLayoutEffect(() => {
    if (!videoUri) {
      videoSlot.src = '';
    } else {
      videoSlot.src = videoUri;
    }
  }, [videoUri]);
}
